import { Genre, GenreLabels } from "@mbb/config";

type Props = {
  value: Genre[];
  onChange: (next: Genre[]) => void;
  label?: string;
};

const ORDER: Genre[] = [
  Genre.ROMANCE,
  Genre.THRILLER_MYSTERY,
  Genre.LITERARY_FICTION,
  Genre.FANTASY_SCIFI,
  Genre.MEMOIR_NONFICTION,
  Genre.YA,
  Genre.HISTORICAL_FICTION,
  Genre.HORROR,
  Genre.ANYTHING,
];

export default function GenrePicker({
  value,
  onChange,
  label = "Favorite genres",
}: Props) {
  function toggle(g: Genre) {
    if (value.includes(g)) {
      onChange(value.filter((v) => v !== g));
    } else {
      onChange([...value, g]);
    }
  }
  return (
    <fieldset
      style={{
        border: 0,
        padding: 0,
        margin: 0,
        marginBottom: "1rem",
      }}
    >
      <legend
        className="eyebrow"
        style={{
          color: "var(--c-palm)",
          fontSize: "0.7rem",
          marginBottom: "0.5rem",
          padding: 0,
        }}
      >
        {label}
      </legend>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "0.5rem" }}>
        {ORDER.map((g) => {
          const active = value.includes(g);
          return (
            <button
              type="button"
              key={g}
              onClick={() => toggle(g)}
              aria-pressed={active}
              style={{
                padding: "0.5rem 0.9rem",
                borderRadius: "var(--r-pill)",
                border: `1.5px solid ${active ? "var(--c-palm)" : "var(--c-rule)"}`,
                background: active ? "var(--c-palm)" : "#fff",
                color: active ? "var(--c-sand)" : "var(--c-palm)",
                fontFamily: "var(--f-label)",
                textTransform: "uppercase",
                letterSpacing: "0.1em",
                fontSize: "0.72rem",
                fontWeight: 600,
                cursor: "pointer",
                transition: "background 150ms ease, color 150ms ease",
              }}
            >
              {GenreLabels[g]}
            </button>
          );
        })}
      </div>
    </fieldset>
  );
}
